import { render, staticRenderFns } from "./SubUnitShowButton.vue?vue&type=template&id=766f6b7b&scoped=true&"
import script from "./SubUnitShowButton.vue?vue&type=script&lang=ts&"
export * from "./SubUnitShowButton.vue?vue&type=script&lang=ts&"
import style0 from "./SubUnitShowButton.vue?vue&type=style&index=0&id=766f6b7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766f6b7b",
  null
  
)

export default component.exports